<template>
  <v-layout ma-0 pa-0 row>
  <DialogAskForString ref="dlgSaveHitlistConfig"
    title="TITLE_DIALOG_SAVEHITLISTCONFIG"
  ></DialogAskForString>
  <v-flex v-if="editMode" width="0" ma-0 pa-0>
    <v-toolbar  flat class="blue" height="40px">
      <v-flex v-if="dragging" xs10 text-sm-center error style="cursor:default;"
        @drop="onDrop($event, 'delete')"
        @dragover.prevent
        @dragenter="onDragEnter($event)"
        @dragleave="onDragLeave($event)"
      >
        <v-icon color="white">delete</v-icon>
      </v-flex>
      <v-flex v-else xs10 text-sm-center>
        <v-btn dark class="pa-0 text-none blue" @click.native="onEditMode(false)" small>
          {{ 'BUTT_EDIT_CLOSE' | translate }}
        </v-btn>
      </v-flex>
    </v-toolbar>
    <SearchItemManager v-if="editMode" defaultTab="groups" :currentMask="searchMaskConfig" itemType="hitlistColumns" eventNewFilter="OnModifyMask" :containerHeight="containerHeight-40"></SearchItemManager>
  </v-flex> 
  <div name="grid-container" class="strukturbilanz" :id="'con' + myTableIEId" style="padding-bottom:18px">
    <DialogTableColumns ref="dlg" @doChangeColumns="setNewColumns" :configName="headerConfigName"></DialogTableColumns>
    <DialogOpenLink ref="dlgOpenLink" @doDialogOpenlink="doDialogOpenlink"></DialogOpenLink>
    <div class="Headers" :id="'tableHeaderDIV' + myTableIEId">
      <table v-if="showTable" :id="'h' + myTableIEId" class="newHader ieTable" border="0"
             cellpadding="0" cellspacing="0">
        <tr>
          <th v-if="tableConfig.selection" :class="tableConfig.header.columnClass + ' etableCheckboxCell'">
            <div style="width: 40px;padding-top: 3px;">
              <span index="-1o" :style="getItemDisplay(null, true)" class="ieSpanCheckbox handpointer">
                <img :src="hicon1" width="14" style="padding-top: 0px;margin-left: 10px;">
              </span>
              <span index="-1" :style="getItemDisplay(null, false)" class="ieSpanCheckbox handpointer">
                <img :src="hicon2" width="14" style="padding-top: 0px;margin-left: 10px;">
              <!--selected-->
              </span>
            </div>
          </th>
          <th name="yHead" class="verlauf abstandunten04 theme--light blue tableIEPadding1 headcolumn head0 textcenter">
            <div style="width: 40px">
              <v-menu offset-x>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="white" class="pointer body-1 ml-2 pa-2" >fa fa-bars</v-icon>
                </template>
                <v-list>
                  <v-list-tile @click="onEditMode(true)">
                    <v-list-tile-title class="body-1">{{ 'LISTENTRY_EDIT_HITLISTCONFIG' | translate }}</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="saveHitlistConfig()">
                    <v-list-tile-title class="body-1">{{ 'LISTENTRY_SAVE_HITLISTCONFIG' | translate }}</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="onModifyMask('reset')">
                    <v-list-tile-title class="body-1">{{ 'LISTENTRY_RESET_HITLISTCONFIG' | translate }}</v-list-tile-title>
                  </v-list-tile>
                  <v-divider v-if="hitlistConfigurations && hitlistConfigurations.length > 0"></v-divider>
                  <v-subheader class="caption" v-if="hitlistConfigurations && hitlistConfigurations.length > 0"> {{ 'TITLE_SAVED_HITLISTCONFIGS' | translate }}</v-subheader>
                  <v-list-tile v-for="hitlistConfig in hitlistConfigurations" :key="hitlistConfig.id" @click="loadHitlistConfig(hitlistConfig.title, $event)">
                    <v-list-tile-title class="body-1">{{ hitlistConfig.title }}</v-list-tile-title>
                    <v-list-tile-action class="body-1"><v-icon @click.stop="deleteHitlistConfig(hitlistConfig.title)">delete</v-icon></v-list-tile-action>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </div>
          </th>
          <th v-for="(head, i) in currentHeader" name="tdHead" v-bind:key="head.index"
              :class="tableConfig.header.columnClass + ' ' + getHeadTDClass(null, head.index, head)"
              :headindex="head.index" @dragstart="startDrag($event, head.meta.id)" 
              @drop="onDrop($event, 'movehere')" @dragover.prevent @dragenter="onDragEnter($event)" @dragleave="onDragLeave($event)"
              :draggable="editMode">

            <div name="sortArrows" :indexArrow="head.index" :style="'width:' + getWidth(head) + 'px;'"
                 :class="'disable-select sortArrays ' + getHeadTDClass(null, head.index, head)">
              <v-icon v-if="!sortDisabled" name="sort" headUp small color="#8ACAC1">arrow_downward</v-icon>
              <v-icon v-if="!sortDisabled" name="sort" headDown small color="#8ACAC1">arrow_upward</v-icon>
              <!--<v-icon v-if="head.meta.balance != null" name="link" color="white">link</v-icon>-->
              <span :headindex="head.index" name="hhead" :style="'width:' + (getWidth(head) - 5) + 'px;'"
                    :class="getHeadClass(head, true) + ' disable-select spantextda'"
                    :title="getTooltip(head)" :text="getTooltip(head)"
                    v-html="getHeaderText(head)">
              </span>
            </div>
          </th>
          <th :class="tableConfig.header.columnClass" style="width: 100%;" :headindex="currentHeader.length"
            @drop="onDrop($event, 'movehere')" @dragover.prevent @dragenter="onDragEnter($event)" @dragleave="onDragLeave($event)"
          >
            &nbsp;
          </th>
        </tr>
      </table>
    </div>
    <div class="Table" :id="'tableDIV' + myTableIEId" :style="'height:' + alternateTableHeight + 'px'">
      <table :id="myTableIEId" class="MyTable ieTable noborder">
        <!-- key="item.guid" -->
        <tr v-for='item in tableItems' :id="item.trItem" @click="toggleItem(item)"
            :style="'' + item.trStyle" :class="'hdrIndex' + item.hdrIndex + ' ' + item.trClass" :hdrIndex="item.hdrIndex"
            v-if="!(tableConfig.hideCategories && item.isCategoryItem)">
          <td v-bind:key="item.guid" width="32" v-if="tableConfig.selection && !item.selectedInSession && !item.isCategoryItem" :class="item.tdClasses[currentHeader[0].id]" style="text-align: center" class="witdhcheckbox">
            <span ico="1o" :index="item.index+'o'" :style="item.itemDisplayTrue" class="ieSpanCheckbox icon1">
              <img :src="icon1" width="14" style="padding-top: 0px;">
            </span>
              <span ico="1" :index="item.index" :style="item.itemDisplayFalse" class="ieSpanCheckbox">
              <img :src="icon2" width="14" style="padding-top: 0px;">
            </span>
          </td>
          <td width="40" :style="'width:40px;'" :class="item.tdClasses[currentHeader[0].id]" class="witdhcheckbox">
          </td>
          <td v-if="tableConfig.selection && item.selectedInSession">
            <span :index="item.index" :style="item.itemDisplayFalse" class="ieSpanCheckbox"><v-icon small>check_box</v-icon></span>
          </td>
          <td :class="item.divClasses['-1']" v-if="tableConfig.selection && (!item.selectedInSession) && item.isCategoryItem"></td>

          <td :style="item.styles[head.id]" v-for="head in currentHeader"  v-bind:key="head.id"
              :class="item.tdClasses[head.id]" :text="item.hints[head.id]"
              :title="item.hints[head.id]" :colspan="item.colSpan" v-if="(item.variables[head.id] && item.variables[head.id]['visible']) || head.meta.type === 'spare'">
            <div v-if="head.meta.type === 'spare'" :style="'width:' + (getWidth(head) - 5) + 'px;'">&nbsp;</div>

            <div v-if="tableConfig.actionButtons && (head.format==='action' && tableConfig.actionButtons.buttons)" :style="'display:flex; width:' + item.widths[head.id] + 'px'">
              <span w-data="foo" style="display:flex;">
                <v-icon
                  v-for="(button,i) in tableConfig.actionButtons.buttons" v-bind:key="i"
                  v-if="item.buttonVisible[button.index]"
                  @click="onActionButton(button, item)"
                  v-on="on"
                  :title="getButtonToolTip(button, item)"
                  :color="button.color">
                  {{button.icon}}
                </v-icon>
              </span>
            </div>
            <v-checkbox v-if="head.format==='chkbox'" v-model="cModel">x</v-checkbox>
            <div :class="'collapseButton'" name="collapser" :hdrIndex="item.toggleHDRIndex"
                 v-if="item.isCategoryItem && head.index === 1">
              <v-icon up style="display: none;" small color="#8ACAC1" :hdrIndexUp="item.toggleHDRIndex"
                      :hdrIndex="item.toggleHDRIndex">arrow_downward
              </v-icon>
              <v-icon down small color="#8ACAC1" :hdrIndexDown="item.toggleHDRIndex" :hdrIndex="item.toggleHDRIndex">
                arrow_upward
              </v-icon>
            </div>
            <div :style="item.divStyles[head.id]"
                 v-if="head.format!=='chkbox' && head.format!=='action' && head.meta.type !== 'spare'"
                 :class="item.divClasses[head.id]"
                 :text="item.hints[head.id]"
                 :title="item.hints[head.id]">
            <span :style="item.variables[head.id]['spanStyle']">
              <v-tooltip top v-if="head.id === 1 && item.tooltipIcon">
                <template v-slot:activator="{ on }">
                  <v-icon small v-on="on" color="#004884">info</v-icon>
                </template>
                <v-card max-width="400px">
                  <v-container>
                    <div style="" v-html="item.tooltipIcon.text" class="text-xs-left"></div>
                  </v-container>
                </v-card>
              </v-tooltip>
              <span style="padding-top: 4px; padding-right: 50px;" v-if="item.variables[head.id] && item.variables[head.id]['prefix']">{{item.variables[head.id]['prefix']}}</span>
              <span v-if="item.variables[head.id] && item.variables[head.id]['display'] === 'ampel2'">
                <Ampel style="display: inline-flex;float:right;" :cnt="2" :state="item.variables[head.id]['co']"></Ampel>
              </span>
              <span v-if="((head.meta.id === 'ID-TITLE') || (head.meta.type === 'title')) && item.variables[head.id] && item.variables[head.id]['kzf']" :title="$t('TOOLTIP_KZF_INFO')">
                <v-icon down small color="#8ACAC1" @click="onKZFButton(item, item.variables[head.id]['kzfdata'])">info</v-icon>
              </span>
              <span v-if="item.variables[head.id] && item.variables[head.id]['display'] === 'ampel3'">
                <Ampel style="display: inline-flex" :cnt="3" :state="item.variables[head.id]['co']"></Ampel>
              </span>
              <v-tooltip top v-if="(item.variables[head.id] && item.variables[head.id]['display'] === 'score') && (item.cos[head.id])">
                <template v-slot:activator="{on}">
                    <img v-on="on"  :src="'./static/bankscoreColorcode' + getCOOneDigit(item, head) + '.png'" style="padding-top:4px;padding-left: 4px;max-width: 100px;margin-right: -5px;">
                </template>
                <v-card flat>
                <v-card-text>
                  <v-layout row>
                    <div class="mt-2 mr-1">{{'BASCO_BAD_SCORE'| translate}}</div>
                    <img width="150" height="auto" :src="'./static/Legende_BASCO.png'"/>
                    <div class="mt-2 ml-1">{{'BASCO_GOOD_SCORE'| translate}}</div>
                  </v-layout>
                </v-card-text>
              </v-card>
              </v-tooltip>
              <span v-if="hasAmpel && !(item.variables[head.id] && item.variables[head.id]['display'])"
                    :style="'width:' + (item.widths[head.id] - 20) + 'px' + ';'" v-html="item.cos[head.id]"></span>
              <span v-if="false && hasAmpel && !(item.variables[head.id] && item.variables[head.id]['display'])"
                    :style="'width:' + (item.widths[head.id] - 20) + 'px' + ';'" v-html="item.cos[head.id]"></span>
              <span v-if="!hasAmpel && !(item.variables[head.id] && item.variables[head.id]['display'])" :style="'width:' + item.widths[head.id] + 'px' + ';'" v-html="item.cos[head.id]">
              </span>
              <span :name="head.id" v-if="!((head.meta.id === 'ID-TITLE') || (head.meta.type === 'title')) && item.variables[head.id] && item.variables[head.id]['kzf']" :title="$t('TOOLTIP_KZF')">
                <v-icon down small color="#8ACAC1" @click="onKZFButton(item, item.variables[head.id]['kzfdata'])">functions</v-icon>
              </span>
              <Ampel v-if="hasAmpel" cnt="1" :color="getAmpelState(item,head)" state="fixed"></Ampel>
            </span>
            </div>

          </td>
          <td :class="item.tdClasses[1]" style="width: 100%;" v-if="item.visible">
          </td>
        </tr>
      </table>
    </div>
  </div>
  </v-layout>
</template>

<script>
  import Vue from 'vue'
  import Ampel from './../widgets/TrafficLight'
  import DialogTableColumns from './../module/dialogs/DialogTableColumns'
  import DialogOpenLink from './../module/dialogs/DialogOpenLink'
  import SearchItemManager from './../module/mask/SearchItemManager';
  import DialogAskForString from "../module/dialogs/DialogAskForString";
  var _ = require('lodash')
  var $ = require('jquery')
  export default {
    name: 'EasyTableIE',
    props: [
      'configSuffix', 'tableName', 'tableTooltips', 'levelST', 'selectedFunc', 'fixedHeight', 'hasAmpel', 'sortDisabled', 'headers', 'maxHeight', 'widthSub',
      'heightSub', 'heightCRSSub', 'items', 'downloads', 'tableNotComplete', 'tableConfig', 'selected', 'currency', 'ankerBank', 'clickEventName', 'RowBKGFromSource',
      'containerHeight', 'configChangeEventName', 'hitlistConfigurations'
    ],
    components: {DialogOpenLink, DialogTableColumns, Ampel, SearchItemManager, DialogAskForString },
    data() {
      return {
        editMode: false,
        dragging: false,
        searchMaskConfig: [],
        hitlistConfigChanged: false,

        lastSelection: [],
        on: null,
        idModule: null,
        alternateTableHeight: 100,
        headerConfigName: 'TableConfig',
        isResizeDirty: false,
        isResizeDirtyTm: -1,
        myId: '0815',
        doResizeAfterUpdateFlag: false,
        txtNoBalanceData: Vue.i18n.translate('TOOLTIP_NO_BALANCE_DATA'),
        originalData: null,
        ttData1: {},
        currentHeader: null,
        initialHeader: null,
        'myTableIEId': 'xTable' + new Date().getTime(),
        'isShow': false,
        fixedWidth: -1,
        'myItems': null,
        hintCharAlternativ: '-',
        hintChar: '*',
        blockSetHeight: false,
        abFilterFields: null,
        numberRegex: /^\s*[+-]?(\d+|\.\d+|\d+\.\d+|\d+\.)(e[+-]?\d+)?\s*$/,
        'icon2': './static/check_box.png', // selected
        'icon1': './static/check_box_outline_blank.png',
        'hicon1': './static/check_box_outline_blank_white.png', // head Icon
        'hicon2': './static/check_box_white.png', // head Icon
        'cc': 1,
        selectAll: false,
        isCRS: Vue.prototype.$config.IS_CRS,
        showTable: false,
        renderComponent: false,
        radioGroup: [],
        'tableItems': [],
        'currentOrder': null,
        'colorCheck': true,
        'currentOrderDir': 'desc',
        'tableHeight': 'max-height: 200px;',
        'tableWidth': 'width: 800px;',
        'itemsVisible': []
      }
    },
    watch: {
      headers: function (newValue) {
        Vue.prototype.$api.debug('==============headers changing');
        this.currentHeader = []
        this.currentHeader = _.clone(newValue, true)
      }
    },
    methods: {
      onEditMode (newMode) {
        this.editMode = newMode;
        this.doResize();
        if (newMode == false) {
          // We are currently reloading after every change
          //Vue.prototype.$eventHub.$emit(this.configChangeEventName, 'reload');
        }
      },

      onModifyMask (action, filterId, refFilterId) {
        const cmp = this;
        Vue.prototype.$api.debug('EasyTable onModifyMask called', {action: action, filterId: filterId, refFilterId: refFilterId});
        let filterList = [];
        if (action === 'add' || action === 'remove' || action === 'move') {
          Vue.prototype.$api.debug('INfo gathering: ', { currentHeader: this.currentHeader, initalHeader: this.initialHeader });
          Vue.prototype.$eventHub.$emit(this.configChangeEventName, action, filterId, refFilterId);

          return;
        }
        if (action === 'reset') {
          Vue.prototype.$eventHub.$emit(this.configChangeEventName, action);
          return;
        }
      },
      saveHitlistConfig () {
        const cmp = this;
        this.$refs.dlgSaveHitlistConfig.open('TEXT_DIALOG_SAVEHITLISTCONFIG', { 
          defaultAnswer: '', //this.currentRulesetName,
        },
        function (answer) {
          Vue.prototype.$eventHub.$emit(cmp.configChangeEventName, 'save', answer);
        });
      },
      loadHitlistConfig (hitlistConfigName) {
        Vue.prototype.$eventHub.$emit(this.configChangeEventName, 'load', hitlistConfigName);
      },
      deleteHitlistConfig (hitlistConfigName) {
        Vue.prototype.$eventHub.$emit(this.configChangeEventName, 'delete', hitlistConfigName);
      },
      startDrag(event, data) {
        Vue.prototype.$api.debug('startDrag', {event: event, data: data });
        this.dragging = true;
        event.dataTransfer.dropEffect = 'move';
        event.dataTransfer.effectAllowed = 'move';
        event.dataTransfer.setData('itemData', data);
      },
      onDragEnter (event) {
        event.target.classList.add('dropzoneactive');
      },
      onDragLeave (event) {
        event.target.classList.remove('dropzoneactive');
      },
      onDrop(event, data) {
        const itemID = event.dataTransfer.getData('itemData');
        this.dragging = false;

        Vue.prototype.$api.debug('onDrop', {event: event, data: data, itemID: itemID, headindex: event.target.attributes['headindex'] });
        if (data === 'delete') {
          this.onModifyMask('remove', itemID);
          this.onDragLeave(event);
          return;
        }
        if (data === 'movehere') {
          const destindex = event.target.offsetParent.cellIndex;
          if (event.dataTransfer.getData('itemAction') === 'add') {
            this.onModifyMask('add', itemID, destindex);
          }
          else {
            this.onModifyMask('move', itemID, destindex);
          }
          this.onDragLeave(event);
          return;
        }
        this.onDragLeave(event);
      },

      getHint(item, head) {
        if (head.value === '0') {
          if (item && item.meta && item.meta.hasOwnProperty('balanceAvailable') && !item.meta.balanceAvailable) {
            return this.txtNoBalanceData
          }
        }
        if (item && head && item[head.value]) {
          return item[head.value].tt
        }
        return ''
      },
      isNumber(s) {
        return this.numberRegex.test(s)
      },
      openLink(company) {
        this.$refs.dlgOpenLink.open({
          name: 'Un',
          company: company
        });
      },
      doDialogOpenlink(data) {
        Vue.prototype.$api.debug('doDialogOpenlink', data, this.idModule)
        this.$router.push({
          name: 'Forward',
          params: {url: Vue.prototype.$api.getStructureUrl(this.idModule, data.company)}
        })

      },
      getAmpelState(item, head) {
        if (item && head && item[head.value]) {
          return item[head.value].bgr
        }
        return ''
      },
      setNewColumns(columns) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        this.currentHeader = columns
        window.setTimeout(this.activateTable, 80)
        this.lastHeaderCnt = cmp.currentHeader.length
      },
      onKZFButton (item, head) {
        // console.log('onKZFButton', item, head)
        Vue.prototype.$eventHub.$emit('onKZFButton', {
          type: item.meta.type,
          id: item.meta.id,
          head: head
        })
      },
      showColumnDialog() {
        // console.log('initialHeader', this.initialHeader)
        this.$refs.dlg.open({
          title: Vue.i18n.translate('COL_CONFIG'),
          type: '',
          description: Vue.i18n.translate('COL_CONFIG_DES'),
          columns: this.initialHeader
        })
      },
      getVariable(item, head, key) {
        if (item[head.value] && item[head.value][key]) {
          return item[head.value][key]
        }
        return ''
      },
      getCOOneDigit(item, head) {
        var digits = this.getCO(item, head)
        digits = digits.replace(',', '.') * 1
        digits = Math.floor(digits)
        return digits
      },
      getCO(item, head) {

        if (item[head.value]) {
          var value = item[head.value].co
          var type = head.meta.type
          var format = head.meta.format

          if (item[head.value] && item[head.value].format) {
            format = item[head.value].format
          }
          if (item[head.value] && item[head.value].type) {
            type = item[head.value].type
          }

          if (!format) {
            format = ''
          }

          if ((type === 'comp-icon') || (type === 'comp-ref-icon') || (type === 'trendicon')) {
            var color = 'textcolor-green'
            var i = item[head.value].co
            if (i === '') return ''
            if (i === 0) return ''
            var arrow = ''
            if (i === -1) {
              arrow = 'arrow_drop_down'
              color = 'textcolor-red'
            }
            if (i === 1) arrow = 'arrow_drop_up'
            if (value === 'gu') {
              arrow = 'arrow_drop_up'
              color = 'textcolor-green'
            } else if (value === 'gd') {
              arrow = 'arrow_drop_down'
              color = 'textcolor-green'
            } else if (value === 'ru') {
              arrow = 'arrow_drop_up'
              color = 'textcolor-red'
            } else if (value === 'rd') {
              arrow = 'arrow_drop_down'
              color = 'textcolor-red'
            }
            if (arrow !== '') {
              value = '<i aria-hidden="true" class="' + color + ' v-icon material-icons theme--light">' + arrow + '</i>'
            }
            return '' + value
          }

          if (value || (value === 0)) {
            var valueBefore = value
            if ((format.toLowerCase() === '')) {
              return value
            }
            if ((format.toLowerCase() === 't')) {
              return value
            }

            if (head.dimension) {
              if (this.isNumber(value)) {
                value = value * (1.0 / head.dimension.factor)
              }
            }

            if ((type === 'sp') && this.isNumber(value)) {
              value = Vue.prototype.$api.convertToWaimeaDecimal(format, value)
              var cur = Vue.prototype.$api.getI18NCurrency(this.currency).name
              value = value + ' ' + cur
            } else if ((type === 'raw') && this.isNumber(value)) {
              value = Vue.prototype.$api.convertToWaimeaDecimal(format, value)
            } else if ((type === 'kz') && this.isNumber(value)) {
              value = Vue.prototype.$api.convertToWaimeaDecimal(format, value)
            } else if ((format.toLowerCase() === 'f2t')) {
              value = Vue.prototype.$api.convertToWaimeaDecimal(format, value)
            } else if ((format.toLowerCase() === 'f0t')) {
              value = Vue.prototype.$api.convertToWaimeaDecimal(format, value)
            } else if ((format.toLowerCase() === 'f1t')) {
              value = Vue.prototype.$api.convertToWaimeaDecimal(format, value)
            } else if ((format.match(/^[nwpf]\d+$/))) {
              value = Vue.prototype.$api.formatLocaleNumber(format, value);
            }
          }
          if (value === 'NaN') {
            Vue.prototype.$api.debug('valueBefore', valueBefore, value)
          }
          /*
          */
          var hint = this.getHint(item, head)
          var hasHint = hint != null && (hint.length > 0)
          if (hasHint) {
            if (this.tableConfig.hideHintStars) {

            } else {
              if (value && value.length > 0) {
                // value = value + '<sup class="hintChar">' + this.hintChar + '</sup>'
              } else {
                value = value + '<sup class="hintCharAlternativ">' + this.hintCharAlternativ + '</sup>'
              }
            }
          }
        }
        if (!value) value = ''
        if (value === 'undefined') value = ''
        if (head.dimension) {
          value = value + ' ' + head.dimension.name
        }
        return value
      },
      forceRerender() {
        // Remove my-component from the DOM
        this.renderComponent = false

        this.$nextTick(() => {
          // Add the component back in
          this.renderComponent = true
        })
      },
      collapse(item, index) {
        if (this.itemsVisible['' + index]) {
          window.jQuery('table[id=' + this.myTableIEId + ']').find('tr[hdrIndex=' + index + ']').show()
          window.jQuery('table[id=' + this.myTableIEId + ']').find('i[hdrIndexUp=' + index + ']').hide()
          window.jQuery('table[id=' + this.myTableIEId + ']').find('i[hdrIndexDown=' + index + ']').show()

          this.itemsVisible['' + index] = false
        } else {
          window.jQuery('table[id=' + this.myTableIEId + ']').find('tr[hdrIndex=' + index + ']').hide()
          window.jQuery('table[id=' + this.myTableIEId + ']').find('i[hdrIndexUp=' + index + ']').show()
          window.jQuery('table[id=' + this.myTableIEId + ']').find('i[hdrIndexDown=' + index + ']').hide()
          this.itemsVisible['' + index] = true
        }
      },
      isCategoryItem(item) {
        if (item.meta) {
          if (item.meta.type === 'hdr') return true
        }
        return false
      },
      isLastItem(item) {
        if (item.meta) {
          if (item.meta.type === 'lastItem') return true
        }
        return false
      },
      isButtonVisible(button, item) {
        if (button.type === 'check' || button.type === 'event') {
          if (!button.checkProperty || item.meta[button.checkProperty]) {
            return true
          }
          return false
        }
        return true
      },
      getButtonToolTip(button, item) {
        if (button.type === 'check') {
          return item.meta.alertText
        }
        return button.tooltipText
      },
      onActionButton(button, item) {
        if (button.type === 'remove') {
          this.deleteRow(item);
          this.$emit('onItemDeleted', {
            button: button,
            item: item,
            items: this.items
          });
          return;
        }
        if (button.type === 'event') {
          this.$emit('onActionButtonClick', { button: button, item: item });
          return;
        }
      },
      deleteRow(item) {
        var index = this.items.indexOf(item);
        this.items.splice(index, 1);

        index = this.tableItems.indexOf(item);
        this.updateData(_.orderBy(this.items, ['sort' + this.currentOrder], [this.currentOrderDir]));
      },
      setFixedWidth(width) {
        this.fixedWidth = width
      },
      getItemDisplay(item, isOutline) {
        var selected = false
        if (item) {
          selected = item.selected
        } else {
          selected = this.selectAll
        }

        if (isOutline) {
          selected = !selected
        }
        if (selected) {
          return 'display: inline;'
        } else {
          return 'display: none;'
        }
      },
      getHeaderText(head) {
        var cur = Vue.prototype.$api.getI18NCurrency(this.currency).name
        if (cur) {
          if (head.value === 'balanceSum') {
            return head.text + ' (' + cur + ')'
          }
        }
        return head.text
      },
      getIdForItem(item) {
        if (this.isAnkerBank(item)) {
          return 'ankerBankRef'
        } else {
          return item.index + '' + item.id
        }
      },
      toggleItem(item) {
        this.lastSelection = _.clone(this.getSelectedRows())

        if (item.meta.type === 'txt') {
          this.$emit(item.meta.btnType, item)
        }
        if (this.isCategoryItem(item)) {
          this.collapse(item, item.toggleHDRIndex)
        }
        if (this.tableConfig.isClickable) {
          item.tableConfig = this.tableConfig
          if (this.clickEventName) {
            Vue.prototype.$eventHub.$emit(this.clickEventName, item)
          } else {
            Vue.prototype.$eventHub.$emit('ETClickOnRow', item)
          }

        } else if (this.tableConfig.selection) {
          if (this.selectedFunc) {
            this.selectedFunc(item, this.tableItems, this)
          }
          if (this.isAnkerBank(item)) return
          if (item.selectedInSession) return
          if (item.selected) {
            item.meta.value = 0
            this.removeItem(item)
          } else {
            item.meta.value = 1
            this.addItem(item)
          }
        } else {
          Vue.prototype.$api.debug('toggleItem not configured in tableconfig', this.tableConfig)
        }
        var cmp = this
        this.$nextTick(function () {
          cmp.$emit('selectedRows', {
            selected: cmp.getSelectedRows(),
            selectedBefore: cmp.lastSelection
          })
        })
        if (this.selectAll) {
          this.selectAll = false
        }
      },
      getSelectedRows() {
        var s = []
        for (var itemIndex in this.items) {
          var value = this.items[itemIndex]
          if (value.selected) {
            s.push(value)
          }
        }
        return s
      },
      addItem(item) {
        item.selected = true
        window.jQuery('table[id=' + this.myTableIEId + ']').find('span[index=' + item.index + ']').show()
        window.jQuery('table[id=' + this.myTableIEId + ']').find('span[index=' + item.index + 'o]').hide()
      },
      removeItem(item) {
        item.selected = false
        window.jQuery('table[id=' + this.myTableIEId + ']').find('span[index=' + item.index + 'o]').show()
        window.jQuery('table[id=' + this.myTableIEId + ']').find('span[index=' + item.index + ']').hide()
      },
      getTRStyle(item) {
        let style = ''
        if (this.RowBKGFromSource) {
          if (item && item.meta.bgrColor  && item.meta.type !== 'nm' && item.meta.bgrColor.length > 0) {
            style = 'background-color: #' + item.meta.bgrColor
          }
        }
        return style
      },
      getTRClass(item) {
        var cClass = this.tableConfig.rows.rowClass
        if (item.selectedInSession) {
          cClass = cClass + ' grayReadOnly'
        }
        if (this.tableConfig.isClickable) {
          cClass = cClass + ' handpointer'
        }
        if (item && item.meta && item.meta.hasOwnProperty('balanceAvailable') && item.meta.balanceAvailable) {
          cClass = cClass + ' balanceAvailable'
        }
        if (item && item.meta && item.meta.hasOwnProperty('balanceAvailable') && !item.meta.balanceAvailable) {
          cClass = cClass + ' balanceNotAvailable'
        }
        return cClass
      },
      getHeadTDClass(item, i, head) {
        var cClass = ''
        if (i >= 2000) {
          cClass += ' pfhttausend'
        }
        if (head) {
          cClass = cClass + ' head' + head.id
        }
        var align = this.convertAlignToClass(head.meta.headerAlign)
        if (align) {
          cClass += ' ' + align
        }
        if (this.editMode) cClass += ' draggable';
        return cClass
      },
      getTDClass(item, i) {
        var cClass = ''

        if (item) {
          if (item.isBold || this.isAnkerBank(item)) {
            cClass += ' fontBold'
          }
        }
        if (item) {
          if ((item.meta.fontBold === 1) || (item.meta.fontBold === true)) {
            cClass += ' fontBold'
          }
        }
        if (this.isCategoryItem(item)) {
          cClass += ' blueCategory'
        }
        if (this.isLastItem(item)) {
          cClass += ' lastItemCategory'
        }
        if (this.tableConfig.isClickable) {
          cClass = cClass + ' handpointer'
        }
        if (i >= 2000) {
          cClass += ' pfhbodyttausend'
        }

        cClass += ' cell' + i
        cClass += ' cell'

        return cClass
      },
      getClassValue(i, item, isBody) {
        if (!item) return 'ftmyColumn ftmyColumn' + i
        var bold = ''
        if (item.isBold) {
          bold = 'fontBold '
        }
        if (i === -1) {
          if (isBody) {
            return bold + 'ftmyColumn ftBodyLeft ftmyColumn' + i
          }
          return bold + 'ftmyColumn ftBodyRight ftmyColumn' + i
        }
        if (item.isMonitaer && i < 1000) {
          return bold + 'text-xs-right ftmyColumn ftmyColumn' + i
        } else {
          if (!item.isMonitaer) {
            return bold + 'text-xs-left ftmyColumn ftmyColumn' + i
          }
          if (i === 1000) {
            return bold + 'text-xs-left ftmyColumn ftmyColumn' + i
          }
          return bold + 'text-xs-right ftmyColumn ftmyColumn' + i
        }
      },
      getTypeOfItem(item, headColumn) {
        if (headColumn.i === -1) {
          return item.type
        }
        return item.type
      },
      checkDimension() {
        Vue.prototype.$api.debug('checkDimension')
        this.activateTable()
      },
      getValueFromItem(item, _header) {
        var value = item[_header.value]
        if (_header.value === 'rechtskreis') {
          var e = Vue.prototype.$api.getI18NRechtsKreis(item.rechtskreis)
          if (e) {
            return e.title
          }
        } else if (_header.value === 'country') {
          e = Vue.prototype.$api.getI18NCountry(item.country)
          if (e) {
            return e.title
          }
        } else if (_header.value === 'branch') {
          e = Vue.prototype.$api.getI18NBranche(item.branch)
          if (e) {
            return e.title
          }
        } else if (_header.value === 'abschlussart') {
          e = Vue.prototype.$api.getI18NAbschlussart(item.abschlussart)
          if (e) {
            return e.title
          }
        } else if (_header.value === 'balanceSum') {
          /* Overwrite value here with bSum */
          if (!this.isAnkerBank(item)) {
            value = item['balanceSumKurs']
          } else {
            value = this.ankerBank.balanceSum
          }

          if (!Number.isFinite(value)) {
            var maximumFractionDigits = 0
            var minimumFractionDigits = 0
            var vvv = (1 * value).toLocaleString('de-DE', {
              style: 'decimal',
              useGrouping: true,
              maximumFractionDigits: maximumFractionDigits,
              minimumFractionDigits: minimumFractionDigits
            })

            var cur = Vue.prototype.$api.getI18NCurrency(this.currency).name
            if (cur) {
              return vvv + ' ' + cur
            }
            return vvv
          }
        }
        if (value.length === 0) {
          return '-'
        }
        return value
      },
      getCellClass(head, item) {
        var css = ' '
        if (this.isCategoryItem(item)) {
          css += ' cellCategory'
        }
        if (!head) return css

        if (head.value === 'year') {

        } else if (head.value === 'name') {

        } else if (head.value === 'country') {

        } else if (head.value === 'abschlussart') {

        } else if (head.value === 'rechtskreis') {

        } else if (head.value === 'branch') {

        } else if (head.value === 'balanceSum') {
          css += ' right'
        }
        var align = this.convertAlignToClass(head.meta.align)
        if (align) {
          css += ' ' + align
        }

        return css
      },
      convertAlignToCss(align) {
        if (align === 'L') align = 'left'
        if (align === 'C') align = 'center'
        if (align === 'R') align = 'right'
        return align
      },
      convertAlignToClass(align) {
        if (align === 'L') align = 'textleft'
        if (align === 'C') align = 'textcenter'
        if (align === 'R') align = 'textright'
        return align
      },
      isAnkerBank(item) {
        if (item.meta && item.meta.balance && item.meta.balance.isAnkerBank) {
          return true
        }
        return false
      },
      getCellStyleDiv(head, item) {
        var css = ''
        if (this.isAnkerBank(item)) {
          css += 'font-weight: bold;'
        }
        if (this.tableConfig.selection) {
          if (head.value === '0') {
            if (head.meta.align === 'C') {
              css += 'padding-left:25px;'
            }
          }
        }
        if (item[head.value] && item[head.value].bgr) {
          if (!this.hasAmpel) {
            css += ';background-color:#' + item[head.value].bgr
            // css +=';font-weight:bold; color:green;'
          }
        }
        if (item[head.value] && item[head.value].bgrColor) {
          if (!this.hasAmpel) {
            css += ';border-color:#' + item[head.value].bgrColor
          }
        }

        var align = 'left'
        if (item[head.value] && item[head.value].align) {
          align = this.convertAlignToCss(item[head.value].align)
          css += ';text-align:' + align + ' !important;'
        } else if (head && head.meta && head.meta.align) {
          align = this.convertAlignToCss(head.meta.align)
          css += ';text-align:' + align + ' !important;'
        }
        if (item && item.meta && item.meta.type === 'txt') {
          css += 'padding-top:10px;'
        }
        return css
      },
      getCellStyle(head, item) {
        var css = ''
        var align = 'left'
        align = this.convertAlignToCss(head.meta.align)
        if (align) {
          css = 'text-align:' + align + ';'
        }

        if (this.isCategoryItem(head)) {
          if (head.meta.bgrColor) {
            css += 'background-color: #' + head.meta.bgrColor + ';'
          }
          if (head.meta.fontColor) {
            css += 'color: #' + head.meta.fontColor + ';'
          }
          if (head.meta.fontBold) {
            css += 'font-weight: bold;'
          }
        }
        if (item && item.meta && item.meta.bgrColor) {
          css += 'background-color: #' + item.meta.bgrColor + ';'
        }
        if (head && item) {
          if (this.getVariable(item, head, 'display') === 'score') {
            css += 'vertical-align:bottom;'
          }
        }
        return css
      },
      getCellWidth(head, item) {
        var css = ''
        var width = this.convertMetaWith(head.meta.width)
        var align = 'center'
        if (width != null) {
          css += 'min-width: ' + width + 'px;  max-width: ' + width + 'px;'
        }
        css += ' text-align:' + align + ';'
        return css
      },
      convertMetaWith(width) {
        if (!width) return null
        width = width * 8
        return width
      },
      getWidth(head, item) {
        var isRowItem = item != null
        var width = this.convertMetaWith(head.meta.width)
        if (this.hasAmpel) {
          width = this.convertMetaWith(head.meta.width * 1.2)
        }
        if (this.tableConfig.selection && isRowItem) {
          if (head.value === '0') {
            width -= 5
          }
        }
        return width
      },
      getColor(item) {
        var bkg1 = 'white'
        var bkg2 = '#fafafa'
        var style = ''
        if (item.isModulo === 1) {
          bkg1 = '#f5f5f5'
          bkg2 = '#fafafa'
        }
        if (this.colorCheck) {
          if (item.bkgColor === 'DDEBF2') {
            bkg1 = '#fafafa'
            style += 'background-color: ' + bkg1 + '; border-bottom:2px solid #249fe1;'
            return style
          } else if (item.bkgColor === 'E2E2E2') {
            style += 'background-color: ' + bkg2 + '; color:#5f5e5e;'
            return style
          }
        }
        if (item.bkgColor) {
          style += 'background-color: ' + bkg1 + ';'
        }
        return style
      },

      isVisible(item) {
        return true
      },
      getTooltip(head) {
        if (head.meta.tt) {
          return head.meta.tt
        } else {
          return head.text
        }
      },
      getHeadClass(head, isHead) {
        var cl = 'headSpan'
        if (head && (head.value === 'balanceSum')) {
          cl = cl + ' headSpanExtra'
        }
        if (head && head.isExtraField) {
          cl = cl + ' extraField';
        }
        return cl
      },
      viewport() {
        var e = window
        var a = 'inner'
        if (!('innerWidth' in window)) {
          a = 'client'
          e = document.documentElement || document.body
        }
        return {width: e[a + 'Width'], height: e[a + 'Height']}
      },
      getWidthSub(sub) {
        // console.log('navigator.platform', navigator.platform)
        if (navigator.platform.toLowerCase().indexOf('win') > -1) {
          sub = sub + 0
        }
        return sub
      },
      setTableHeight() {
        var cmp = this
        var footerHeight = $('#footerMenu').height()
        var view = this.viewport()
        var h2 = view.height - footerHeight - Vue.config.data.TABLE_SHRINK_HEIGHT - 36
        var menuContentHeight = $('#menuContent').height()
        var tabbarWidth = view.width
        var h = menuContentHeight - 71
        h = h2
        var w = tabbarWidth
        var footerHeight = 35;
        var topNavigationHeight = 65;
        var sub = 0;
        if (this.isCRS) {
          if (this.heightCRSSub) {
            sub = this.heightCRSSub
          }
          h = view.height - sub;
        } else {
          if (this.heightSub) {
            sub = this.heightSub
          }
          h = view.height - footerHeight - topNavigationHeight - sub;
        }
        if (this.containerHeight) {
          h = this.containerHeight - 58 - 35;
        }
        if (this.maxHeight && this.maxHeight !== -1) {
          if (h > this.maxHeight) {
            h = this.maxHeight
          }
        }
        if (this.maxHeight === -1) {
          this.blockSetHeight = true
        }

        sub = 0
        if (this.widthSub) {
          sub = this.widthSub
        }
        sub = this.getWidthSub(sub)
        // console.log('w', w, sub)
        if (this.fixedWidth === -1) {
          w = view.width - sub
        } else {
          w = this.fixedWidth - sub
        }
        // console.log('w', w, sub)

        var params = {
          autoResize: false,
          width: w,
          autoShow: true,
          cloneHeadToFoot: false,
          footer: false,
          fixedColumn: false,
          fixedColumns: 0
        }
        if (cmp.fixedHeight) {
          h = cmp.fixedHeight - 40
          params.height = h
        }
        if (!(this.maxHeight && this.maxHeight === -1) && (!this.blockSetHeight)) {
          params.height = h
        }

        $('div[name=grid-container]').css('width', (w - 48) + 'px')

        Vue.prototype.$api.debug('xdoResize', [params.width, params.height])
        cmp.renderComponent = true
      },
      isToggled(item, index) {
        return this.itemsVisible['' + index]
      },
      onClickSelectAll() {
        let cmp =this
        this.lastSelection = _.clone(this.getSelectedRows())
        var value = null
        var itemIndex = -1
        if (!this.selectAll) {
          console.log('selectAll')
          window.jQuery('table[id=' + this.myTableIEId + ']').find('span[index=' + (-1) + ']').show()
          window.jQuery('table[id=' + this.myTableIEId + ']').find('span[index=' + (-1) + 'o]').hide()
          for (itemIndex in this.items) {
            value = this.items[itemIndex]
            const isAnker = this.isAnkerBank(value)

            if (isAnker) {
              value.selected = true
              continue
            }
            if (!value.selectedInSession && !value.selected) {
              value.selected = true
            }
            window.jQuery('table[id=' + this.myTableIEId + ']').find('span[index=' + (value.index) + ']').show()
            window.jQuery('table[id=' + this.myTableIEId + ']').find('span[index=' + (value.index) + 'o]').hide()
            this.tableItems[itemIndex].selected = value.selected
            this.items[itemIndex].selected = value.selected
          }
        } else {
          console.log('deselectAll')
          window.jQuery('table[id=' + this.myTableIEId + ']').find('span[index=' + (-1) + ']').hide()
          window.jQuery('table[id=' + this.myTableIEId + ']').find('span[index=' + (-1) + 'o]').show()
          for (itemIndex in this.items) {
            value = this.items[itemIndex]
            const isAnker = this.isAnkerBank(value)

            if (isAnker) {
              value.selected = true
              continue
            }

            if (!value.selectedInSession && value.selected) {
              value.selected = false
            }
            window.jQuery('table[id=' + this.myTableIEId + ']').find('span[index=' + (value.index ) + ']').hide()
            window.jQuery('table[id=' + this.myTableIEId + ']').find('span[index=' + (value.index ) + 'o]').show()
            this.tableItems[itemIndex].selected = value.selected
            this.items[itemIndex].selected = value.selected


          }
        }
        var s = []
        for (itemIndex in this.items) {
          value = this.items[itemIndex]
          if (value.selected) {
            s.push(value)
          }
        }
        this.$emit('selectedRows', {
          selected: s,
          selectedBefore: cmp.lastSelection
        })
        this.selectAll = !this.selectAll
      },
      setAlternateTableHeight() {
        this.setTableHeight()
          var cmp = this
          var footerHeight = $('#footerMenu').height()
          var view = this.viewport()
          var h2 = view.height - footerHeight - Vue.config.data.TABLE_SHRINK_HEIGHT.TABLE_SHRINK_HEIGHT - 36

          var menuContentHeight = $('#menuContent').height()
          var tabbarWidth = $('#tabbarWidth').width()
          var h = menuContentHeight - 71
          h = h2
          var w = tabbarWidth
          var footerHeight = 35;
          var topNavigationHeight = 65;
          var sub = 0;
          if (this.isCRS) {
            if (this.heightCRSSub) {
              sub = this.heightCRSSub
            }
            h = view.height - sub;
          } else {
            if (this.heightSub) {
              sub = this.heightSub
            }
            h = view.height - footerHeight - topNavigationHeight - sub;
          }
          if (this.containerHeight) {
            h = this.containerHeight - 16;
          }

          if (this.maxHeight && this.maxHeight !== -1) {
            if (h > this.maxHeight) {
              h = this.maxHeight
            }
          }

          sub = 0
          if (this.widthSub) {
            sub = this.widthSub
          }
          sub = this.getWidthSub(sub)
          if (this.fixedWidth === -1) {
            w = view.width - sub
          } else {
            w = this.fixedWidth - sub
          }
          if (cmp.fixedHeight) {
            h = cmp.fixedHeight
          }

          var params = {
            autoResize: false,
            width: w,
            autoShow: true,
            cloneHeadToFoot: false,
            footer: false,
            fixedColumn: false,
            fixedColumns: 0
          }
          if ((this.maxHeight && this.maxHeight > - 1)) {
            if (this.maxHeight  > h) {
              this.maxHeight = h
            }
          }
          params.height = h
          var counter = 0;
          this.alternateTableHeight = params.height - 60 - (this.editMode ? (57+8+8) : 0);
      },
      doRenderTable() {
        Vue.prototype.$api.debug('DoRenderTable')
        var cmp = this
        var footerHeight = $('#footerMenu').height()
        var view = this.viewport()
        var h2 = view.height - footerHeight - Vue.config.data.TABLE_SHRINK_HEIGHT.TABLE_SHRINK_HEIGHT - 36

        var menuContentHeight = $('#menuContent').height()
        var tabbarWidth = $('#tabbarWidth').width()
        var h = menuContentHeight - 71
        h = h2
        var w = tabbarWidth
        var footerHeight = 35;
        var topNavigationHeight = 65;
        var sub = 0;
        if (this.isCRS) {
          if (this.heightCRSSub) {
            sub = this.heightCRSSub
          }
          h = view.height - sub;
        } else {
          if (this.heightSub) {
            sub = this.heightSub
          }
          h = view.height - footerHeight - topNavigationHeight - sub;
        }
        if (this.maxHeight && this.maxHeight !== -1) {
          if (h > this.maxHeight) {
            h = this.maxHeight
          }
        }

        sub = 0
        if (this.widthSub) {
          sub = this.widthSub
        }
        sub = this.getWidthSub(sub)
        if (this.fixedWidth === -1) {
          w = view.width - sub
        } else {
          w = this.fixedWidth - sub
        }

        var params = {
          autoResize: false,
          width: w,
          autoShow: true,
          cloneHeadToFoot: false,
          footer: false,
          fixedColumn: false,
          fixedColumns: 0
        }
        if (!(this.maxHeight && this.maxHeight === -1)) {
          params.height = h
        }

        var counter = 0;

        window.jQuery('div[id=tableDIV' + this.myTableIEId + ']').bind('scroll', function () {
          window.jQuery('div[id=tableHeaderDIV' + cmp.myTableIEId + ']').scrollLeft($(this).scrollLeft());
        })
        window.jQuery('table[id=h' + this.myTableIEId + ']').find('.etableCheckboxCell').unbind()
        window.jQuery('table[id=h' + this.myTableIEId + ']').find('.etableCheckboxCell').click(function () {
          cmp.onClickSelectAll()
        })
        if (!this.sortDisabled) {
          //console.log('init sort func', 'div[id=con' + this.myTableIEId + '].find(div[name="sortArrows"]).find(i[name=sort])')
          window.jQuery('div[id=con' + this.myTableIEId + ']').find('div[name="sortArrows"]').find('i[name=sort]').hide()
          window.jQuery('div[id=con' + cmp.myTableIEId + ']').find('th[name="tdHead"]').unbind()
          window.jQuery('div[id=con' + cmp.myTableIEId + ']').find('th[name="tdHead"]').click(function (event) {
            var headIndex = window.jQuery(event.target).attr('headindex')
            var head = cmp.currentHeader[headIndex - 1]
            if (cmp.tableConfig.actionButtons) {
              head = cmp.currentHeader[headIndex]
            }
            if (head) {
              if (head.meta.balance) {
                cmp.openLink(head.meta.balance)
              } else {
                cmp.doOrder(head.value)
              }
            }
          })
        }
        Vue.prototype.$api.debug('td')
        Vue.prototype.$api.debug('css')
        $('div[name=grid-container]').css('width', (w) + 'px')
        Vue.prototype.$api.debug('css')
        cmp.doScroll()

        cmp.renderComponent = true
        Vue.prototype.$api.hideIdle()
        Vue.prototype.$api.debug('DoRenderTable done')
      },
      activateTable(setActive) {
        Vue.prototype.$api.debug('activateTable')
        var cmp = this

        // window.setTimeout(function () {
        if (!setActive) {
          this.showTable = true
        }

        if (this.showTable) {
          if (cmp.renderComponent === true) {
            Vue.prototype.$api.debug('renderComponent so destroy table')
            this.doDestroyTable(true)
          }
          // this.$nextTick(this.doRenderTable)
          Vue.prototype.$api.debug('activateTable done')
          window.setTimeout(this.doRenderTable, 200)
        }
        // console.log('doResize', this.doResizeAfterUpdateFlag)
      },
      doDestroyTable(isRerender) {
        Vue.prototype.$api.debug('doDestroyTable')
        window.jQuery('div[id=tableDIV' + this.myTableIEId + ']').unbind()
        window.jQuery('div[id=h' + this.myTableIEId + ']').find('.etableCheckboxCell').unbind()
        window.jQuery('div[id=' + this.myTableIEId + ']').find('.etableCheckboxCell').unbind()
        window.jQuery('div[id=' + this.myTableIEId + ']').find('div[name="hhead"]').unbind()
        window.jQuery('#' + this.myTableIEId).fixedHeaderTable('destroy')
        this.renderComponent = false
        if (!isRerender) {
          this.tableItems = []
          this.currentHeader = []
        }
        this.data = {idModule: null,
          alternateTableHeight: 100,
          isResizeDirty: false,
          isResizeDirtyTm: -1,
          txtNoBalanceData: Vue.i18n.translate('TOOLTIP_NO_BALANCE_DATA'),
          originalData: null,
          ttData1: {},
          currentHeader: null,
          'myTableIEId': 'xTable' + new Date().getTime(),
          'isShow': false,
          fixedWidth: -1,
          'myItems': null,
          blockSetHeight: false,
          abFilterFields: null,
          numberRegex: /^\s*[+-]?(\d+|\.\d+|\d+\.\d+|\d+\.)(e[+-]?\d+)?\s*$/,
          'icon2': './static/check_box.png', // selected
          'icon1': './static/check_box_outline_blank.png',
          'hicon1': './static/check_box_outline_blank_white.png', // head Icon
          'hicon2': './static/check_box_white.png', // head Icon
          'cc': 1,
          selectAll: false,
          isCRS: Vue.prototype.$config.IS_CRS,
          showTable: false,
          renderComponent: false,
          radioGroup: [],
          'tableItems': [],
          'currentOrder': null,
          'colorCheck': true,
          'currentOrderDir': 'asc',
          'tableHeight': 'max-height: 200px;',
          'tableWidth': 'width: 800px;',
          'itemsVisible': []}
      },
      doScroll() {
        var cmp = this
        cmp.$nextTick(function () {
          var VueScrollTo = require('vue-scrollto')
          var options = {
            container: $('div[id=tableDIV' + cmp.myTableIEId + ']')[0],
            easing: 'ease-in',
            offset: -($('div[id=tableDIV' + cmp.myTableIEId + ']').height() * 0.5),
            force: true,
            cancelable: true,
            onStart: function (element) {
              // scrolling started
              Vue.prototype.$api.debug('scrollto', element, 'div[id=tableDIV' + cmp.myTableIEId + ']')
            },
            onDone: function (element) {
              Vue.prototype.$api.debug('onDone', element)
            },
            onCancel: function () {
              Vue.prototype.$api.debug('onCancel')
            },
            x: false,
            y: true
          }
          var element = $('#ankerBankRef')[0]
          if (element) {
            VueScrollTo.scrollTo(element, 500, options)
          }
        })
      },
      getAll() {
        var result = []
        for (var itemIndex in this.tableItems) {
          var item = this.tableItems[itemIndex]
          result.push(item)
        }
        return result
      },
      getSelected() {
        var result = []
        for (var itemIndex in this.tableItems) {
          var item = this.tableItems[itemIndex]
          if (item.selected) {
            result.push(item)
          }
        }
        return result
      },
      setOrderBy(head) {
        Vue.prototype.$api.debug('order', head)
      },
      doOrder(newOrder) {
        window.jQuery('div[id=con' + this.myTableIEId + ']').find('div[name="sortArrows"]').find('i[name=sort]').hide()
        window.jQuery('div[id=con' + this.myTableIEId + ']').find('div[indexArrow=' + ((newOrder * 1) + 1) + ']').show()
        if (this.currentOrder === newOrder) {
          if (this.currentOrderDir === 'desc') {
            this.currentOrderDir = 'asc'
          } else {
            this.currentOrderDir = 'desc'
          }
        } else {
          this.currentOrderDir = 'asc'
        }
        this.currentOrder = newOrder
        if (this.currentOrderDir === 'asc') {
          window.jQuery('div[id=con' + this.myTableIEId + ']').find('div[indexArrow=' + ((newOrder * 1) + 1) + ']').find('i[headUp]').hide()
          window.jQuery('div[id=con' + this.myTableIEId + ']').find('div[indexArrow=' + ((newOrder * 1) + 1) + ']').find('i[headDown]').show()
        } else {
          window.jQuery('div[id=con' + this.myTableIEId + ']').find('div[indexArrow=' + ((newOrder * 1) + 1) + ']').find('i[headUp]').show()
          window.jQuery('div[id=con' + this.myTableIEId + ']').find('div[indexArrow=' + ((newOrder * 1) + 1) + ']').find('i[headDown]').hide()
        }

        let sortedItems = _.orderBy(this.items, ['sort' + this.currentOrder], [this.currentOrderDir])
        this.doResizeAfterUpdateFlag = true
        this.updateData(sortedItems, true, this.currentOrder)
      },
      clearMemoryLeaks() {
        this.tableItems = []
        // window.jQuery('#' + this.myTableIEId).empty()
      },
      decodeHTMLEntitiesDOM(str) {
        var txt = document.createElement('textarea');
        txt.innerHTML = str;
        // element.node.removeChild(node);
        return txt.value;
      },
      decodeHTMLEntities(str) {
        return str.replace(/&#([0-9]{1,3});/gi, function (match, numStr) {
          var num = parseInt(numStr, 10); // read num as normal number
          return String.fromCharCode(num);
        })
      },
      getSortString(item, head, defValue) {
        var str = ('' + this.getCO(item, head)).toLowerCase()
        var original = str
        // str = this.decodeHTMLEntities(str)
        str = str.replace(/\u00e4/g, "ae")
        str = str.replace(/\u00fc/g, "ue")
        str = str.replace(/\u00f6/g, "oe")
        str = str.replace(/\u00df/g, "ss")
        str = str.replace('İ', 'I')
        str = str.replace('Č', 'C')
        str = str.replace('Å', 'A')

        if (head && head.meta && (head.meta.type === 'sp' || head.meta.type === 'kz')) {
          str = ('' + str).replace(/\./g, '')
          str = ('' + str).replace(/,/g, '.')
          try {
            var arr = str.split(' ')
            if (arr.length > 0) {
              str = arr[0]
              str = str.replace(/\./g, '')

              var minChars = 20
              var diff = minChars - str.length
              for (var i = 0; i < diff; i++) {
                str = '0' + str
              }
            }
          } catch (e) {
            console.error('sortString', e)
          }
        }
        str = ('' + str).toLowerCase()
        return str
      },
      updateHeader(newHeader) {
        if (newHeader) {
          this.headers = newHeader
          this.currentHeader = []
          this.currentHeader = _.clone(newHeader, true)
          this.lastHeaderCnt = -1
        }
      },
      orderIsSet () {
        let isSet =  this.currentOrder
        return isSet
      },
      updateData(xdata, forceActivate, sortBy) {
        var data = xdata
        var cmp = this
        this.setAlternateTableHeight()
        this.selectAll = false
        this.headerConfigName = Vue.prototype.$api.getModuleId() + '_' + this.configSuffix + 'TC' + this.tableName
        Vue.prototype.$api.debug('EasyTableIE - updateData', 'sortBy' + sortBy)
        var dontHide = false
        if (cmp.initialHeader === null) {
          cmp.initialHeader = _.clone(this.headers, true)
        }
        cmp.currentHeader = []
        cmp.currentHeader = _.clone(this.headers, true)
        // console.log('this.headerConfigName', this.headerConfigName)
        let userHeader = Vue.prototype.storage.getStorage(this.headerConfigName, null)
        if (userHeader) {
          let newHeader = []
          _.forEach(userHeader, function (head) {
            if (head.isVisible) {
              newHeader.push(head)
            }
          })
          cmp.currentHeader = _.clone(newHeader, true)
        }
        if (forceActivate || (this.lastHeaderCnt !== cmp.currentHeader.length)) {
          dontHide = true
          window.setTimeout(this.activateTable, 80)
        }
        if (!dontHide) {
          Vue.prototype.$api.hideIdle()
        }
        this.lastHeaderCnt = cmp.currentHeader.length
        var rowIndex = 0
        var hdrIndex = 0
        // TODO: currentHeaderFields is obsolete. check this feature below
        let hf = Vue.prototype.storage.currentHeaderFields
        let itemscurrencydimension = Vue.prototype.storage.getCurrencyDimensionList()
        _.forEach(cmp.currentHeader, function (head) {
          let curIndex = _.findIndex(hf, function (o) {
            return o.type + '-' + o.id === head.meta.id
          })
          if (curIndex > -1) {
            let hfItem = hf[curIndex]
            head.dimensionIndex = hfItem.dimension
            curIndex = _.findIndex(itemscurrencydimension, function (o) {
              return (o.id === head.dimensionIndex) && o.id !== '1'
            })
            if (curIndex > -1) {
              head.dimension = itemscurrencydimension[curIndex]
            }
          } else {
            // check Search Fields now here.
            let maskConfig = Vue.prototype.storage.getState('searchMaskConfig')
            if (maskConfig) {
              for (var index in maskConfig.config) {
                var entry = maskConfig.config[index]
                var id = entry.type + '-' + entry.field
                if (id === head.meta.id) {
                  head.dimensionIndex = entry.dimension
                  curIndex = _.findIndex(itemscurrencydimension, function (o) {
                    return (o.id === head.dimensionIndex) && o.id !== '1'
                  })
                  if (curIndex > -1) {
                    head.dimension = itemscurrencydimension[curIndex]
                  }
                }
              }
            }
          }
        })

        _.forEach(data, function (value) {
          value['index'] = rowIndex
          value['guid'] = new Date().getTime() + rowIndex
          value['selected'] = false

          value['selectedInSession'] = false
          if (value['meta'] && value['meta'].value === 1) {
            value['selected'] = true
          }

          value['hdrIndex'] = -1
          if (cmp.isCategoryItem(value)) {
            value.isCategoryItem = true
            hdrIndex = hdrIndex + 1
            value['toggleHDRIndex'] = hdrIndex
          } else {
            value.isCategoryItem = false
            value['hdrIndex'] = hdrIndex
          }

          value.styles = []
          value.colSpan = 1
          value.divStyles = []
          value.hints = []
          value.divClasses = []
          value.tdClasses = []
          value.variables = []
          value.widths = []
          value.cos = []
          value.buttonVisible = []
          var item = value

          if (cmp.tableTooltips && value['meta'] && value['meta'] && cmp.tableTooltips) {

            for (let [key, keyValue] of Object.entries(cmp.tableTooltips)) {
              if (value['meta'][key]) {
                // console.log('found', value['meta'][key], cmp.tableTooltips[key])
                item.tooltipIcon = {
                  text: cmp.tableTooltips[key].text
                }
              }
            }

          }

          value.itemDisplayTrue = cmp.getItemDisplay(item, true)
          value.itemDisplayFalse = cmp.getItemDisplay(item, false)
          value.divClasses['-1'] = 'value' + cmp.getCellClass(null, item)

          item.trItem = cmp.getIdForItem(item)
          item.trClass = cmp.getTRClass(item)
          item.trStyle = cmp.getTRStyle(item)
          if (cmp.tableConfig.actionButtons) {
            _.forEach(cmp.tableConfig.actionButtons.buttons, function (button) {
              value.buttonVisible[button.index] = cmp.isButtonVisible(button, item)
            })
          }

          if (item.meta.type === 'txt') {
            value.colSpan = cmp.currentHeader.length
          }
          if (item.meta.type === 're') {
            // console.log('re - item', item)
          }

          let cIndex = 0
          _.forEach(cmp.currentHeader, function (head) {
            if (!head) {
              console.error('head is null', head, cmp.currentHeader)
            } else {
              value.visible = true
              if (item.meta.type === 'txt') {
                value.visible = cIndex === 0
                value.widths[head.id] = '100%'
                value.divStyles[head.id] = 'width:100%' + cmp.getCellStyleDiv(head, item)
              } else {
                value.widths[head.id] = cmp.getWidth(head, item)
                value.divStyles[head.id] = 'width:' + cmp.getWidth(head, item) + 'px' + ';' + cmp.getCellStyleDiv(head, item)
              }
              value.styles[head.id] = cmp.getColor(item) + ' ' + cmp.getCellStyle(item)
              value.hints[head.id] = cmp.getHint(item, head)
              value.divClasses[head.id] = 'value' + cmp.getCellClass(head, item)
              value.tdClasses[head.id] = 'pfhbody pfhbody' + head.id + cmp.getTDClass(item, head.id)

              let txt = '' + cmp.getCO(item, head)
              try {
                if ((txt + '').indexOf('<btnSupport>') > -1) {
                  item.meta.btnType = 'btnSupport'
                  txt = (txt + '').replace('<btnSupport>', '<a href="javascript:void(0);" @click="' + cmp.onClickSupport + '" >')
                  txt = (txt + '').replace('</btnSupport>', '</a>')
                }
              } catch (e) {
                console.error(e)
              }
              value.cos[head.id] = txt
              value.variables[head.id] = []
              let hasKZF = false
              try {
                let isBanks = (Vue.prototype.$api.getModuleId() === 'banks')
                hasKZF = txt && txt.length > 0 && isBanks && (txt.indexOf('hintCharAlternativ') === -1) && value.meta.id && value.meta.type && item.meta.type !== 'nm' && ((head.meta.type === 'year') || (head.meta.type === 'title'))
                if (hasKZF) {
                  value.variables[head.id]['kzfdata'] = head
                  value.widths[head.id] = cmp.getWidth(head, item) - 30
                }
              } catch (e) {
                console.error(e)
              }
              value.variables[head.id]['kzf'] = hasKZF
              value.variables[head.id]['display'] = cmp.getVariable(item, head, 'display')
              value.variables[head.id]['prefix'] = cmp.getVariable(item, head, 'prefix')
              value.variables[head.id]['spanStyle'] = 'display:inline-flex;vertical-align: bottom;'
              if (cmp.RowBKGFromSource) {
                if (item && item.meta && item.meta.fontColor && item.meta.type !== 'nm') {
                  value.variables[head.id]['spanStyle'] += 'color: #' + item.meta.fontColor + ' !important;;'
                }
              }
              if (value.variables[head.id]['display'] === 'score') {
                value.variables[head.id]['spanStyle'] += 'padding-right: 0px !important;'
              }
              value.variables[head.id]['co'] = cmp.getVariable(item, head, 'co')
              value.variables[head.id]['visible'] = value.visible
              value.variables[head.id]['type'] = item.meta.type
              value['sort' + head.value] = cmp.getSortString(value, head, value[head.value])
            }
            cIndex++
          })

          rowIndex++
        })
        this.tableItems = []
        this.tableItems = data

        if (sortBy) {
          this.currentOrder = sortBy - 1
          this.currentOrderDir = 'ASC'
          this.updateData(_.orderBy(this.tableItems, ['sort' + this.currentOrder], [this.currentOrderDir]))
          return
        }
        this.originalData = null
        this.originalData = _.clone(this.tableItems, true)
        if (this.doResizeAfterUpdateFlag) {
          Vue.prototype.$api.debug('doResizeAfterUpdateFlag', this.doResizeAfterUpdateFlag)
          this.doResizeAfterUpdateFlag = false
          Vue.prototype.$api.showIdle()
          window.setTimeout(function () {
            cmp.doResize()
            Vue.prototype.$api.hideIdle()
          }, 2000)
        }

        Vue.prototype.$api.debug('updateData done')
      },
      filterWithString(keyword) {
        if (keyword) {
          keyword = keyword.toLowerCase()
          this.tableItems = _.filter(this.originalData, function (o) {
            if (!keyword || keyword.length === 0) return true
            var str = JSON.stringify(o).toLowerCase()
            if (str.indexOf(keyword) > -1) return true
            return false
          })
        }
      },
      getABExtraFieldValue(item, _header) {
        this.abFilterFields = Vue.prototype.storage.abFilterFields
        if (this.abFilterFields) {
          var value = this.abFilterFields[_header.value]
          if (!Number.isFinite(value)) {
            var maximumFractionDigits = 0
            var minimumFractionDigits = 0
            return (1 * value).toLocaleString('de-DE', {
              style: 'decimal',
              useGrouping: true,
              maximumFractionDigits: maximumFractionDigits,
              minimumFractionDigits: minimumFractionDigits
            })
          }
          return value
        }
        return ''
      },
      onClickSupport () {
        console.log('onClickSupport')
      },
      getExtraFieldValue(item, _header) {
        var value = item[_header.value]
        if (item.isAnkerBank) {
          value = this.ankerBank[_header.value]
        }
        if (!Number.isFinite(value)) {
          var maximumFractionDigits = 0
          var minimumFractionDigits = 0
          return (1 * value).toLocaleString('de-DE', {
            style: 'decimal',
            useGrouping: true,
            maximumFractionDigits: maximumFractionDigits,
            minimumFractionDigits: minimumFractionDigits
          })
        }
        return value
      },
      doResize() {
        this.doResizeAfterUpdateFlag = false
        Vue.prototype.$api.debug('doResize')
        this.setAlternateTableHeight()
        this.activateTable(true)
      }
    },
    mounted() {
      var cmp = this
      this.myId = new Date().getTime()

      this.currentHeader = []
      this.currentHeader = _.clone(this.headers, true)
      this.idModule = this.$route.params.idModule
    },
    created() {
      Vue.prototype.$eventHub.$on('OnResize', this.doResize);
      Vue.prototype.$eventHub.$on('OnModifyMask', this.onModifyMask);
    },
    destroyed() {
      Vue.prototype.$eventHub.$off('OnResize', this.doResize)
      Vue.prototype.$eventHub.$off('OnModifyMask', this.onModifyMask);
    }
  }
</script>

<style scoped>
  .fht-tbody {
    overflow: auto !important;
    overflow-y: visible !important;
    overflow-x: hidden !important;
  }
  .Headers {
    overflow-x: hidden;
    overflow-y: hidden;
  }
  .Table {
    overflow: auto;
  }
  .balanceAvailable {
    font-weight: 600;
  }
  .balanceNotAvailable {
    color: #7F7F7F;
  }
  .dropzone {
    min-height: 15px;
    border-radius: 5px;
    background-color: #f0f0f0;
  }
  .dropzoneactive {
    background-color: lightgrey !important;
    min-height: 40px;
  }
  .pseudobutton {
    margin: 4px;
    padding: 12px;
    border-radius: 8px;
    cursor:pointer;
  }
  .draggable {
    cursor:grab !important;
  }
  .value {
    padding-left: 4px;
  }
  span[name="hhead"] {
    padding-left: 4px;
  }
  .extraField {
    font-style: italic;
  }
</style>


// WEBPACK FOOTER //
// src/components/tables/EasyTableIE.vue